import * as React from 'react';
import { observer } from 'mobx-react';
import './eventReservationPane.module.scss';

import { observable } from 'mobx';
import { NotFoundPage } from '../../../../mainv2/containers/common/NotFoundPage';
import { GlobalLoader } from '../../../../mainv2/components/GlobalLoader';
import { ReservationPaneState } from './states/ReservationPaneState';
import { BackButton } from '../../../../commonv3/components/atoms/buttons/BackButton';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';
import { V3Routes } from '../../../routes';
import { ReservationPane, ReservationSubPanes } from '../../atoms/reservations/ReservationPane';
import { ReservationSummaryPane } from '../../molecules/reservations/ReservationSummaryPane';
import { ReservationActionPane } from '../../molecules/reservations/ReservationActionPane';
import { ReservationPaneHeader } from '../../atoms/reservations/ReservationPaneHeader';

type Props = {
    match: {
        params: {
            eventId: string;
        };
    };
};

@observer
export class EventReservationPane extends React.Component<Props> {
    @observable pageState = new ReservationPaneState();
    async componentDidMount() {
        const { eventId } = this.props.match.params;
        await this.pageState.init(Number(eventId));
    }
    render() {
        const { submitting, event: eventResource, alreadyReserved, submit } = this.pageState;
        if (eventResource.isNotFound()) {
            return <NotFoundPage entityType="イベント" />;
        }
        if (eventResource.loading) {
            return <GlobalLoader />;
        }
        const event = eventResource.get();
        if (alreadyReserved) {
            GlobalStatesV3.routing.push(
                V3Routes.eventReservationError(event.id, 'このイベントはすでに予約されています')
            );
            return null;
        }
        return (
            <ReservationPane id="event-reservation-pane">
                <BackButton />
                <ReservationPaneHeader>予約内容の確認</ReservationPaneHeader>
                <ReservationSubPanes>
                    <ReservationSummaryPane title={event.title} reservable={event} />
                    <ReservationActionPane submitting={submitting} onSubmit={submit} />
                </ReservationSubPanes>
            </ReservationPane>
        );
    }
}
